<div class="standard-select-form-field">
  <mat-select
    panelClass="standard-select-panel-class dropdown-tree-panel-class max-height-250"
    #selectElement
    disableOptionCentering="true"
    [(ngModel)]="selectedDropdownItem"
    [ngClass]="listboxClass"
    [disabled]="isDisabled"
    id="dropdownTreeSelect"
  >
    @for (item of dropdownData; track item; let parentIndex = $index) { @if (item.children?.length)
    {
    <mat-optgroup class="dropdown-tree-optgroup">
      <span (click)="expandDropdownItems(item.text)">
        <span>{{ item.text }}</span>
        <mat-icon>
          {{ expandedDropdownMap[item.text] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
      </span>
      @for (childItem of item.children; track childItem; let childIndex = $index) {
      <mat-option
        class="no-padding"
        [value]="childItem.text"
        [ngClass]="{ 'parent-collapsed': !expandedDropdownMap[item.text] }"
        (click)="onDropdownItemSelect($event, item.text, parentIndex, childIndex)"
      >
        {{ childItem.text }}
      </mat-option>
      }
    </mat-optgroup>
    <div class="first-item" [ngClass]="{ 'parent-expanded': expandedDropdownMap[item.text] }">
      <mat-option
        class="no-padding"
        [value]="item.text"
        (click)="onDropdownItemSelect($event, item.text, parentIndex)"
      >
        {{ item.text }}
      </mat-option>
    </div>
    } @else {
    <mat-option
      class="no-padding"
      [value]="item.text"
      (click)="onDropdownItemSelect($event, item.text, parentIndex)"
      >{{ item.text }}</mat-option
    >
    } }
  </mat-select>
</div>
